@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.login
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.models.Language
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengers.UserPreferencesDto

object UpdateUserPerformancesEndpoint : EndPoint<UpdateUserPerformancesEndpoint.Request, UpdateUserPerformancesEndpoint.Response>() {
    class Request (
        val passengerId: KmmLong,
        val preferences: UserPreferencesDto
    )

    class Response
}

